export const cleanYoutubeUrl = (url: string): string => {
	return url.replace('/www.', '/').replace('-nocookie', '');
};
